import { render, staticRenderFns } from "./service.vue?vue&type=template&id=179f0cbe&scoped=true&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"
import style0 from "../pc.css?vue&type=style&index=0&id=179f0cbe&scoped=true&lang=css&"
import style1 from "../phone.css?vue&type=style&index=1&id=179f0cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f0cbe",
  null
  
)

export default component.exports